import { useEffect, useState } from 'react'
import { apiURL } from '../../utilities/URLs'
import { customerData } from '../../utilities/CustomerData'
import { refreshAccessToken } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'
import { useChartConnect } from '@chartapi/react-connect'
import posthog from 'posthog-js'

export default function ChartNew8821Flow() {
  const navigate = useNavigate()
  const [error, setError] = useState(false)
  const [sessionSettingsId, setSessionSettingsId] = useState('')
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState(false)

  const onSuccess = ({ code }) => {
    handleUploadChartCode(code)
  }

  const onError = ({ errorMessage }) => {
    posthog.capture('chart_error', { error_message: errorMessage })
  }

  const onClose = () => console.log('User exited Chart Connect')

  const { open } = useChartConnect({
    clientId: process.env.REACT_APP_CHART_CLIENT_ID,
    zIndex: 999,
    sandbox: false,
    flow: 'irs-8821-prefilled',
    sessionSettingsId,
    onSuccess,
    onError,
    onClose
  })

  const handleUploadChartCode = async (code) => {
    setLoading(true)

    const chartInstantFlowResponse = await fetch(`${apiURL}/api/chart-reauth-flow?contactId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}&code=${encodeURIComponent(code)}&leadStageId=${encodeURIComponent(customerData.customerLeadData.leadStage.leadStageId)}`, {
      method: 'GET',
      headers: {
        'Authorization': customerData.accessToken
      }
    })

    const chartInstantFlowData = await chartInstantFlowResponse.json()
    if(chartInstantFlowData.response.error) {
      if(chartInstantFlowData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleUploadChartCode(code) : navigate('/', { state: { expired: true } })
      } else {
        console.error(chartInstantFlowData.response.error)
        setError(true)
      }
    } else
      setComplete(true)

    setLoading(false)
  }

  useEffect(() => {
    if (sessionSettingsId)
      open()
  }, [sessionSettingsId])

  useEffect(() => {
    const handleGetChartReauthURL = async () => {
      const reauthURLResponse = await fetch(`${apiURL}/api/reauth-chart?contactId=${customerData.customerLeadData.leadContact.contactId}`, {
        method: 'GET',
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const reauthURLData = await reauthURLResponse.json()
      if(reauthURLData.response.error) {
        if(reauthURLData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetChartReauthURL() : navigate('/', { state: { expired: true } })
        } else {
          console.error(reauthURLData.response.error)
          setError(true)
        }
      } else
        setSessionSettingsId(reauthURLData.response.reauthURL)
    }

    handleGetChartReauthURL()
  }, [])

  return (
    <div className='min-h-screen w-screen flex items-center justify-center px-4 bg-gradient-to-br from-blue-50 via-white to-purple-50'>
      <div className='bg-white rounded-2xl shadow-2xl p-10 max-w-lg w-full flex flex-col  gap-8 border border-gray-100 transform transition-all duration-300 hover:shadow-3xl'>
        {!error ? (
          !complete ? (
            <div className='flex flex-col items-center gap-6 animate-fade-in'>
              <div className='text-center space-y-3'>
                <h2 className='text-2xl font-bold text-gray-800 tracking-tight'>Preparing Reauthorization</h2>
                <p className='text-gray-600 leading-relaxed max-w-sm'>We're securely setting up your reauthorization. Please wait just a moment.</p>
                <div className='flex flex-row items-center justify-center gap-2 -mb-5'>
                  <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
                </div>
              </div>
            </div>
          ) : (
            <div className='flex flex-col items-center gap-6 animate-fade-in'>
              <div className='text-center space-y-3'>
                <h2 className='text-2xl font-bold text-gray-800 tracking-tight'>Authorization Complete</h2>
                <p className='text-gray-600 leading-relaxed max-w-sm'>We've securley reauthorized your account. Thank you.</p>
                <button onClick={() => navigate('/dashboard')} className='px-4 py-2 rounded-md shadow-md cursor-pointer text-white bg-green-600'>
                  Dashboard
                </button>
              </div>
            </div>
          )
        ) : (
          <div className='flex flex-col items-center gap-6 animate-fade-in'>
            <div className='text-center space-y-3'>
              <h2 className='text-2xl font-bold text-gray-800 tracking-tight'>Oops! Something Went Wrong</h2>
              <p className='text-gray-600 leading-relaxed max-w-sm'>There was an error preparing your reauthorization flow. Please try again later or contact support if the issue persists.</p>
            </div>
            <button
              onClick={() => window.location.reload()}
              className='mt-4 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-blue-300'
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  )
}